export const DESIGN_EDITOR_BACKGROUND_COLOR = '#f7f7f7';
